import { ArrowDownOutlined, ArrowUpOutlined, DeleteOutlined, ExclamationCircleOutlined, FilterFilled, PlusOutlined, } from "@ant-design/icons";
import { uploadViaBackend } from "../helper/uploadViaBackend";
import { Button, Card, Col, DatePicker, Form, Image, Input, Modal, Row, Table, Tag, } from "antd";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import SingleImageUpload from "../components/SingleImageUpload";
import { AuthContext } from "../context/AuthContext";
import { Severty, ShowToast } from "../helper/toast";
import useDebounce from "../hooks/useDebounce";
import useRequest from "../hooks/useRequest";
import Report from "./Report";

import { Select } from "antd";
import { DownloadExcel } from "../components/ExcelFile";
const { Option } = Select;
const answerTypes = [
  { label: "Free Text", value: "text" },
  { label: "Select from predefined values", value: "select" },
];
const { RangePicker } = DatePicker;

const Search = Input.Search;
const defaultContent = () => ({
  id: Date.now(),
  title: "",
  ar_title: "",
  description: "",
  ar_description: "",
  report: "",
});

let baseURL = "/admin/survey";

function Survey({ type }) {
  const { userPermission, userProfile } = useContext(AuthContext) || {
    userPermission: [],
  };
  const isAdmin = userProfile?.type || "";
  let permissionObject = {
    add: true,
    edit: true,
    delete: true,
  };
  // const permissionMap = (userPermission ?? []).reduce((acc, item) => {
  //   acc[item.name] = item;
  //   return acc;
  // }, {});
  // console.log(permissionMap)

  // if(isAdmin !== "Admin" && permissionMap["gamerManager"]) {
  //   permissionObject.add = permissionMap["gamerManager"].add;
  //   permissionObject.edit = permissionMap["gamerManager"].edit;
  //   permissionObject.delete =  permissionMap["gamerManager"].view;
  //   console.log(permissionMap["gamerManager"]);
  //   console.log(permissionObject);
  // }
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [listExport, setListExport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filter, setFilter] = useState();
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [rowFilter, setRowFilter] = useState({});
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState([]);
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] =
    useState(false);
  const [file, setFile] = useState([]);
  const [certificateModalVisible, setCertificateModalVisible] = useState(false);
  const [certificateCP, setCertificateCP] = useState(null);
  const [image, setImage] = useState(null);
  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const columns = [
  {
  title: "TEAM NAME / LEADER NAME",
  key: "team_or_leader",
  render: (_, record = {}) => {
    const { teamName, surveyType, leaderName } = record || {};

    if (surveyType === "Leader" || surveyType === "FollowUpLeader") {
      return leaderName || teamName || "-";
    }
    return teamName || "-";
  },
}
,
    {
      title: "Survey",
      dataIndex: "surveyType",
      key: "surveyType",
      render: (surveyType) => {
        let displayText = "-";

        switch (surveyType) {
          case "Team":
            displayText = "TPS for Team";
            break;
          case "Leader":
            displayText = "TPS for Leader";
            break;
          case "Foundation":
            displayText = "TPS Foundations";
            break;
          case "FollowUpTeam":
            displayText = "Follow up TPS for Team";
            break;
          case "FollowUpLeader":
            displayText = "Follow up TPS for Leader";
            break;
          case "FollowUpFoundation":
            displayText = "Follow up for TPS Foundations";
            break;
          default:
            displayText = "-";
        }

        return displayText;
      },
    },

    {
      title: "Registration date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, record = {}) => {
        if (!record.created_at) return "-";
        return new Date(record.created_at).toLocaleDateString();
      },

      // render: (_, { created_at }) => {
      //   return new Date(created_at).toLocaleDateString();
      // },
    },
    {
      title: "Action",
      // render: (_, record) => {
      render: (_, record) => {
        if (!record || typeof record !== "object") return "-";
        return (
          <>
            <div className="cta_wrap">

              <Button
                title="View"
                onClick={(e) => {
                  navigate(`/view-survey`, { state: { record } });
                }}
              >
                <i className="fa fa-light fa-eye"></i>
              </Button>
              <Button
                danger
                style={{ marginLeft: 8 }}
                title="Delete"
                onClick={() => {
                  Modal.confirm({
                    content: "Are you sure you want to delete this Survey?",
                    icon: <ExclamationCircleOutlined />,
                    okText: "Yes",
                    cancelText: "No",
                    onOk: () => deleteAccount(record),
                  });
                }}
              >
                <i className="fa fa-trash"></i>
              </Button>

            </div>
          </>
        );
      },
    },
  ];
  useEffect(() => {
    if (certificateModalVisible && certificateCP?.certifications) {
      setImage(certificateCP.certifications); // assume this is the URL
    }
  }, [certificateModalVisible, certificateCP]);
  const uploadFileToS3 = async (file) => {
    // Uploads go through the backend (no S3 keys in the browser).
    return await uploadViaBackend(file, "realState/admin");
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, "invent-colab-obj-bucket");
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  const { confirm } = Modal;

  const deleteAccount = (record) => {
    // alert(record._id)
    request({
      url: `${baseURL}/delete-account/${record ? record._id : ""}`,
      method: "PUT",
      onSuccess: (data) => {
        console.log(data, "data");
        setRefresh(!refresh);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record}?`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/view-customer/${viewData._id}`);
  }, [visibleView]);

  const handleChange = (pagination, filters) => {
    setRowFilter(filters);
    fetchData(pagination, filters);
  };

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : rowFilter.isActive;
    request({
      url: `${baseURL}/list?status=${filterActive ? filterActive.join(",") : ""
        }&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
        }&end_date=${endDate ? endDate : ""}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
          pageSize: pagination.pageSize ?? 10,
        }));
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const handleImage = (data) => {
    const url = data?.[0]?.url || "";
    setImage(url);
  };

  const handleChangeDate = (e) => {
    setStartDate();
    setEndDate();
    if (e && e.length > 0) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    }
  };

  const handleCertificationSubmit = (values) => {
    const payload = { image: image };

    request({
      url: `${baseURL}/certifications/${values}`,
      method: "POST",
      data: payload,
      onSuccess: (res) => {
        ShowToast("Certification submitted successfully!", Severty.SUCCESS);
        fetchData(pagination); // Refresh the data after submission
      },
    });

    setImage(null); // Reset image after submission
  };

  return (
    <>
      <div className="tabled">
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Survey Manager"
              extra={
                <>
                  <Search
                    size="large"
                    placeholder="Search by Name"
                    onChange={onSearch}
                    title="Search by Name"
                    value={searchText}
                    onPressEnter={onSearch}
                  />

                  <Button
                    onClick={() => {
                      request({
                        url: `${baseURL}/export`,
                        method: "GET",
                        onSuccess: (data) => DownloadExcel(data.data.list, "Surveys"),
                        onError: (err) => ShowToast(err?.response?.data?.message, Severty.ERROR),
                      });
                    }}
                  >
                    Export Excel
                  </Button>

                  {/* <Button
                      onClick={(e) => {
                        setVisible(true);
                        setSearchText("");
                      }}
                    >
                      Add Survey
                    </Button> */}
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  rowKey={(record) => record?._id}
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination?.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
          <Col span={24}>
            <Report />
          </Col>
        </Row>
      </div>

      {visible && (
        <AddForm
          file={file}
          setFile={setFile}
          handleChangeImage={handleChangeImage}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {provideSession && (
        <ChangePassword
          show={provideSession}
          hide={() => {
            setSelected();
            setProvideSession(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      <Modal
        title="Comming Soon......"
        open={isRKModalVisible}
        onOk={() => setIsRKModalVisible(false)}
        onCancel={() => setIsRKModalVisible(false)}
      >
        <p>{modalContent}</p>
      </Modal>

      {certificateModalVisible && (
        <Modal
          open={certificateModalVisible}
          title={
            certificateCP.certifications
              ? "Edit CP Certificate"
              : "Create CP Certificate"
          }
          onCancel={() => setCertificateModalVisible(false)}
          footer={null}
        >
          {/* Certificate form goes here */}
          <p>
            Certificate management for:{" "}
            <b>{certificateCP?.name || certificateCP?.userName}</b>
          </p>

          <SingleImageUpload
            value={image}
            fileType={FileType}
            imageType={"Profile"}
            btnName={" Logo"}
            onChange={(data) => handleImage(data)}
            isDimension={false}
          />

          <p className="img-size-details">
            ** Certificate should be in (.png, .jpeg, .jpg .pdf ) format and up
            to 5 MB **
          </p>

          {image && (
            <div className="mt-2 add-img-product mb-4">
              {image.endsWith(".pdf") ? (
                <a href={image} target="_blank" rel="noopener noreferrer">
                  View PDF
                </a>
              ) : (
                <Image width={120} src={image} />
              )}
            </div>
          )}

          <Button
            onClick={() => {
              // Handle certificate submission logic here

              handleCertificationSubmit(certificateCP?._id);
              setCertificateModalVisible(false);
            }}
          >
            Submit
          </Button>
          {/* You can add a form here for certificate details, upload, etc. */}
          {/* On submit, call your API to create/edit certificate */}
        </Modal>
      )}
    </>
  );
}

const AddForm = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();

  const { request } = useRequest();
  const [questions, setQuestions] = useState([]);
  const [reportTypes, setReportTypes] = useState([]);

  // Fetch available report types
  useEffect(() => {
    // Replace with actual API call
    setReportTypes([
      "Feedback Report",
      "Summary",
      "General Report",
      "TPS Foundation",
      "Follow up TPS for Team",
      "Follow up TPS for Leader",
      "Follow up TPS Foundations",
    ]);
  }, []);

  // Load existing data for editing
  useEffect(() => {
    if (data) {
      form.setFieldsValue({ name: data.name, report: data.report });
      setQuestions(data.questions || []);
    } else {
      setQuestions([]);
      form.resetFields();
    }
  }, [data]);

  const addQuestion = () => {
    setQuestions([
      ...questions,
      {
        id: Date.now(),
        text: "",
        type: "text",
        options: [],
      },
    ]);
  };

  const removeQuestion = (index) => {
    const updated = [...questions];
    updated.splice(index, 1);
    setQuestions(updated);
  };

  const moveQuestion = (from, to) => {
    if (to < 0 || to >= questions.length) return;
    const updated = [...questions];
    const [moved] = updated.splice(from, 1);
    updated.splice(to, 0, moved);
    setQuestions(updated);
  };

  const handleQuestionChange = (index, key, value) => {
    const updated = [...questions];
    updated[index][key] = value;

    // Reset options if switching back to text
    if (key === "type" && value === "text") {
      updated[index].options = [];
    }
    setQuestions(updated);
  };

  const handleOptionChange = (qIndex, optIndex, value) => {
    const updated = [...questions];
    updated[qIndex].options[optIndex] = value;
    setQuestions(updated);
  };

  const addOption = (qIndex) => {
    const updated = [...questions];
    updated[qIndex].options.push("");
    setQuestions(updated);
  };

  const onFinish = (values) => {
    console.log("Form submitted", values);

    const payload = {
      name: values.name,
      report: values.report,
      questions,
    };

    if (questions.length <= 0) {
      ShowToast("Minimum 1 Question is required", Severty.ERROR);
      return;
    }

    request({
      url: data ? `/admin/survey/edit/${data._id}` : `/admin/survey/add`, // <-- ensure correct endpoint
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: (res) => {
        ShowToast("Survey saved successfully", Severty.SUCCESS);
        hide();
        refresh?.();
      },
      onError: (err) => {
        ShowToast(
          err?.response?.data?.message || "Failed to save survey",
          Severty.ERROR
        );
      },
    });
  };
  return (
    <Modal
      open={show}
      onCancel={hide}
      title={data ? "Edit Survey" : "Add New Survey"}
      okButtonProps={{ form: "add-survey-form", htmlType: "submit" }}
      footer={null}
    >
      <Form
        layout="vertical"
        form={form}
        id="add-survey-form"
        onFinish={onFinish}
      >
        <Form.Item
          label="Survey Name"
          name="name"
          rules={[{ required: true, message: "Survey name is required" }]}
        >
          <Input placeholder="Enter survey name" />
        </Form.Item>

        <Form.Item
          label="Link to Survey Type"
          name="report"
          rules={[{ required: true, message: "Please select a report type" }]}
        >
          <Select placeholder="Select Survey Type" style={{ width: "100%" }}>
            {reportTypes.map((report) => (
              <Option key={report} value={report}>
                {report}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <div className="main-new-add-question-ainkj">
          <b>Questions</b>
          <Button icon={<PlusOutlined />} type="link" onClick={addQuestion}>
            Add Question
          </Button>
        </div>

        {questions.map((q, index) => (
          <Card
            key={q.id}
            size="small"
            className="main-new-add-question-cardd"
            style={{ marginBottom: 12 }}
            title={`Question ${index + 1}`}
            extra={
              <div className="question-actions-button">
                <Button
                  icon={<ArrowUpOutlined />}
                  onClick={() => moveQuestion(index, index - 1)}
                />
                <Button
                  icon={<ArrowDownOutlined />}
                  onClick={() => moveQuestion(index, index + 1)}
                />
                <Button
                  icon={<DeleteOutlined />}
                  danger
                  onClick={() => removeQuestion(index)}
                />
              </div>
            }
          >
            <Input
              placeholder="Enter question text"
              value={q.text}
              onChange={(e) =>
                handleQuestionChange(index, "text", e.target.value)
              }
              style={{ marginBottom: 8 }}
            />
            <Select
              value={q.type}
              onChange={(value) => handleQuestionChange(index, "type", value)}
              style={{ marginBottom: 8 }}
            >
              {answerTypes.map((type) => (
                <Option key={type.value} value={type.value}>
                  {type.label}
                </Option>
              ))}
            </Select>

            {q.type === "select" && (
              <div>
                <b>Options</b>
                {q.options.map((opt, i) => (
                  <Input
                    key={i}
                    value={opt}
                    placeholder={`Option ${i + 1}`}
                    onChange={(e) =>
                      handleOptionChange(index, i, e.target.value)
                    }
                    style={{ marginBottom: 6 }}
                  />
                ))}
                <Button
                  onClick={() => addOption(index)}
                  size="small"
                  icon={<PlusOutlined />}
                  type="dashed"
                >
                  Add Option
                </Button>
              </div>
            )}
          </Card>
        ))}

        <Form.Item>
          <Button htmlType="submit" type="primary" block>
            {data ? "Update Survey" : "Create Survey"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const ChangePassword = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();

  const [loading, setLoading] = useState(false);
  const onCreate = (values) => {
    setLoading(true);
    request({
      url: `${baseURL}/reset-password/${data._id}`,
      method: `PUT`,
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
          // hide()
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        // console.log(error.response.data, "Error")
        setLoading(false);
        ShowToast(error.response.data.message, Severty.ERROR);
      },
      // onErrorSubmit: (data) => {
      //   console.log(data)
      // }
    });
    // console.log(values)
  };

  return (
    <Modal
      visible={show}
      title={`${data ? "Change password" : "Create a new User"} `}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[0, 0]}>
          <Col span={24}>
            <Form.Item
              label="New Password"
              name="new_password"
              hasFeedback
              rules={[
                { required: true, message: "Please input the new password!" },
                {
                  min: 8,
                  message: "Password must be at least 8 characters long!",
                },
                {
                  pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z]).+$/,
                  message:
                    "Password must contain at least one uppercase letter, one number, and one lowercase letter!",
                },
                {
                  max: 100,
                  message: "Title cannot exceed 100 characters",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Confirm New Password"
              name="confirm_new_password"
              dependencies={["new_password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please input the confirm password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Passwords that you entered do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Survey;
